var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass:
        "gfu-btn gfu-btn--circle gfu-btn--primary _flexinline _jc-c _ai-c",
      attrs: { href: _vm.link, target: "_blank", rel: "noopener noreferrer" },
    },
    [_c("base-icon", { attrs: { name: "help-icon", "icon-namespace": "ga" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }